import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { QRCodeCanvas } from "qrcode.react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  createStyles,
  withStyles,
  InputBase,
} from "@material-ui/core";

import {
  ATALHO_VOLTAR,
  ATALHO_AVANCAR,
  SECONDARY_COLOR,
  SECONDARY_COLOR_OFFLINE,
  formatMoeda,
} from "../../../../../utils";
import { api } from "../../../../../services";
import { AppContext } from "../../../../../app/context";
import { useSnackbar } from "notistack";
import DialogoTipoCredito from "./DialogoTipoCredito";
import {
  AutoCompleteLocal,
  TextInput,
  DateInput,
  PrecoInput,
} from "../../../../../components";
import moment from "moment";
import DialogoTipoCancelamento from "./DialogoTipoCancelamento";

const CANCELAR_VENDA_ACTION = ATALHO_VOLTAR;
const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;
const ESC_ACTION = "Escape";

const useStyles = makeStyles((theme) =>
  createStyles({
    action: {
      display: "flex",
      justifyContent: "space-between",
    },
    root: {
      backgroundColor: theme.palette.background.paper,
    },
    button: {
      color: "white",
      backgroundColor: theme.palette.secondary.main,
    },
    disabledButton: {
      backgroundColor: "red",
    },
  })
);

function getOptionFormatadas(texto) {
  const linhas = texto.split(";");
  const options = [];

  for (let i = 0; i < linhas.length; i++) {
    const dadosLinha = linhas[i].split(":");
    if (dadosLinha[0]) {
      options.push({
        id: dadosLinha[0],
        nome: dadosLinha[1],
      });
    }
  }

  return options;
}

function FormOpcoes({ texto, handleCancelar, handleConfirmar, cabecalho, aguardandoSitef }) {
  const [valor, setValor] = useState("1");
  const inputRef = useRef(null);

  function handleActions(action) {
    switch (action) {
      case FECHAR_VENDA_ACTION:
        handleConfirmar(parseInt(valor, 10));
        break;
      case CANCELAR_VENDA_ACTION:
        handleCancelar(parseInt(valor, 10));
        break;
      case ESC_ACTION:
        handleCancelar(parseInt(valor, 10));
        break;
      default:
        break;
    }
  }

  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  const options = getOptionFormatadas(texto);

  const mapa = {};

  for (let i = 0; i < options.length; i++) {
    mapa[options[i].id] = options[i];
  }

  const valorReal = mapa[valor] ? mapa[valor] : null;

  React.useEffect(() => {
    let timer;
    if (inputRef.current) {
      timer = setTimeout(() => {
        inputRef.current.focus();
        //inputRef.current.select();
      }, 5000); // 1 segundo
    }

    // limpeza pra evitar vazamento de timeout se fechar antes
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >{`${cabecalho}`}</div>
      {/* <div>{texto}</div> */}
      {/* <input
        type="text"
        placeholder="Escolha uma das opções"
        value={valor}
        onChange={(e) => setValor(e.target.value)}
        autoFocus
        onKeyDown={(e) => {
          handleActions(e.key);
        }}
      ></input> */}
      <AutoCompleteLocal
        handleEnter={() => {
          handleActions(FECHAR_VENDA_ACTION);
        }}
        label=""
        handleKey={handleKey}
        value={valorReal}
        onChangeLocal={(value) => {
          if (value) {
            setValor(`${value.id}`);
          } else {
            setValor(options[0].id);
          }
        }}
        campo="nome"
        options={options}
        variant="standard"
        autoFocus={true}
        ref={inputRef}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef}
        >
          {`Cancelar (${CANCELAR_VENDA_ACTION})`}
        </Button>
        <Button
          onClick={() => handleActions(FECHAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef}
        >
          {`Confirmar (${FECHAR_VENDA_ACTION})`}
        </Button>
      </div>
    </div>
  );
}

function FormOpcoesAprimorado({
  texto,
  handleCancelar,
  handleConfirmar,
  cabecalho,
  aguardandoSitef
}) {
  const [valor, setValor] = useState("1");

  function handleActions(action) {
    switch (action) {
      case FECHAR_VENDA_ACTION:
        handleConfirmar(parseInt(valor, 10));
        break;
      case CANCELAR_VENDA_ACTION:
        handleCancelar(parseInt(valor, 10));
        break;
      case ESC_ACTION:
        handleCancelar(parseInt(valor, 10));
        break;
      default:
        break;
    }
  }

  return (
    <div>
      <InputBase
        label=""
        value={cabecalho}
        onChange={() => {}}
        fullWidth
        onKeyDown={(e) => {
          handleActions(e.key);
        }}
        multiline
        autoFocus
        style={{
          margin: 0,
          padding: "10px",
          border: "none",
          outline: "none",
        }}
      />
      <div>{texto}</div>
      <input
        type="text"
        placeholder="Escolha uma das opções"
        value={valor}
        onChange={(e) => setValor(e.target.value)}
      ></input>
      <Button
        onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
        color="secondary"
        variant="contained"
        tabindex="-1"
        disabled={aguardandoSitef}
      >
        {`Cancelar (${CANCELAR_VENDA_ACTION})`}
      </Button>
      <Button
        onClick={() => handleActions(FECHAR_VENDA_ACTION)}
        color="secondary"
        variant="contained"
        tabindex="-1"
        disabled={aguardandoSitef}
      >
        {`Confirmar (${FECHAR_VENDA_ACTION})`}
      </Button>
    </div>
  );
}

function FormSimOuNao({ handleCancelar, handleConfirmar, cabecalho, aguardandoSitef }) {
  function handleActions(action) {
    switch (action) {
      case FECHAR_VENDA_ACTION:
        handleConfirmar();
        break;
      case CANCELAR_VENDA_ACTION:
        handleCancelar();
        break;
      case ESC_ACTION:
        handleCancelar();
        break;
      default:
        break;
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <InputBase
        label=""
        value={cabecalho}
        onChange={() => {}}
        fullWidth
        onKeyDown={(e) => {
          handleActions(e.key);
        }}
        multiline
        autoFocus
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          //backgroundColor: 'red',
          textAlign: "center",
        }}
        inputProps={{
          style: {
            textAlign: "center",
          },
        }}
      />
      <div style={{ display: "flex", gap: "20px" }}>
        <Button
          onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef}
        >
          {`Cancelar (${CANCELAR_VENDA_ACTION})`}
        </Button>
        <Button
          onClick={() => handleActions(FECHAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef}
        >
          {`Confirmar (${FECHAR_VENDA_ACTION})`}
        </Button>
      </div>
    </div>
  );
}

function FormCancel({ handleCancelar, cabecalho, aguardandoSitef }) {
  function handleActions(action) {
    switch (action) {
      case CANCELAR_VENDA_ACTION:
        handleCancelar();
        break;
      case ESC_ACTION:
        handleCancelar();
        break;
      default:
        break;
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <InputBase
        label=""
        value={cabecalho}
        onChange={() => {}}
        fullWidth
        onKeyDown={(e) => {
          handleActions(e.key);
        }}
        multiline
        autoFocus
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          //backgroundColor: 'red',
          textAlign: "center",
        }}
        inputProps={{
          style: {
            textAlign: "center",
          },
        }}
      />
      <Button
        onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
        color="secondary"
        variant="contained"
        tabindex="-1"
        disabled={aguardandoSitef}
      >
        {`Cancelar (${CANCELAR_VENDA_ACTION})`}
      </Button>
    </div>
  );
}

function InputNumeroParcelas({
  tamMaximo,
  tamMinimo,
  valor,
  setValor,
  cabecalho,
}) {
  useEffect(() => {
    setValor("1");
  }, []);

  const minimo = 10 ** tamMinimo - 1;
  const maximo = 10 ** tamMaximo - 1;

  return (
    <input
      type="number"
      min={`${minimo}`}
      max={`${maximo}`}
      value={valor}
      onChange={(e) => setValor(e.target.value)}
      autoFocus
    />
  );
}

const options = [
  {
    id: "2",
    nome: "2x",
  },
  {
    id: "3",
    nome: "3x",
  },
  {
    id: "4",
    nome: "4x",
  },
];

const mapa = {};

for (let i = 0; i < options.length; i++) {
  mapa[options[i].id] = options[i];
}

function InputNumeroParcelasAutocomplete({
  tamMaximo,
  tamMinimo,
  valor,
  setValor,
  cabecalho,
  handleActions,
  label,
}) {
  useEffect(() => {
    setValor("2");
  }, []);

  const valorReal = mapa[valor] ? mapa[valor] : null;

  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {label}
      </div>
      <AutoCompleteLocal
        handleEnter={() => {
          handleActions(FECHAR_VENDA_ACTION);
        }}
        label=""
        handleKey={handleKey}
        value={valorReal}
        onChangeLocal={(value) => {
          if (value) {
            setValor(`${value.id}`);
          } else {
            setValor(`2`);
          }
        }}
        campo="nome"
        options={options}
        variant="standard"
        autoFocus
      />
    </div>
  );
}

const ALLOWED_RE = /[^a-zA-Z0-9]/g;
const ALLOWED_RE_2 = /[^0-9]/g;

function InputCodigoSupervisor({
  tamMaximo,
  tamMinimo,
  valor,
  setValor,
  cabecalho,
  handleActions,
  label,
  erro,
}) {
  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  function sanitize(next) {
    if (!next) return "";
    const onlyAlnum = next.replace(ALLOWED_RE_2, "");
    return onlyAlnum.slice(0, tamMaximo);
    // return next;
  }

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {label}
      </div>
      <TextInput
        name="codigo-supervisor"
        handleEnter={() => handleActions(FECHAR_VENDA_ACTION)}
        label={""}
        handleKey={handleKey}
        value={valor}
        onChange={(value) => setValor(sanitize(value.target.value))}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoFocus
        autoCompleteState="new-password"
        autoComplete="new-password"
        type="password"
      />
    </div>
  );
}

function InputNumeroDocumento({
  tamMaximo,
  tamMinimo,
  valor,
  setValor,
  cabecalho,
  handleActions,
  label,
  erro,
}) {
  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  function sanitize2(next) {
    if (!next) return "";
    const onlyAlnum = next.replace(ALLOWED_RE, "");
    return onlyAlnum.slice(0, tamMaximo);
  }

  function sanitize(next) {
    if (!next) return "";
    const onlyAlnum = next.replace(ALLOWED_RE, "");
    return onlyAlnum.slice(0, tamMaximo);
  }

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {label}
      </div>
      <TextInput
        name="numero-documento"
        handleEnter={() => handleActions(FECHAR_VENDA_ACTION)}
        label={""}
        handleKey={handleKey}
        value={valor}
        onChange={(value) => setValor(sanitize(value.target.value))}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoFocus
      />
    </div>
  );
}

function InputDataTransacao({
  tamMaximo,
  tamMinimo,
  valor,
  setValor,
  cabecalho,
  handleActions,
  label,
  erro,
}) {
  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  function sanitize(next) {
    /* if (!next) return '';
    const onlyAlnum = next.replace(ALLOWED_RE, '');
    return onlyAlnum.slice(0, tamMaximo); */
    return next;
  }

  useEffect(() => {
    setValor(moment().format("DDMMYYYY"));
  }, []);

  function formatDate(dateStr) {
    // dateStr = "30092025" (30/09/2025)
    if (!dateStr) return "";
    const day = dateStr.substring(0, 2);
    const month = dateStr.substring(2, 4);
    const year = dateStr.substring(4, 8);

    return `${year}-${month}-${day}`;
  }

  function formatDateInverse(dateStr) {
    // dateStr = "2025-09-30"
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}${month}${year}`;
  }

  const valorReal = formatDate(valor);

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {label}
      </div>
      {/* <TextInput
        name="numero-documento"
        handleEnter={() => handleActions(FECHAR_VENDA_ACTION)}
        label={""}
        handleKey={handleKey}
        value={valor}
        onChange={(value) => setValor(sanitize(value.target.value))}
        fullWidth
        autoFocus
      /> */}
      <DateInput
        name="data-transacao"
        handleEnter={() => handleActions(FECHAR_VENDA_ACTION)}
        label={""}
        handleKey={handleKey}
        value={valorReal}
        onChange={(value) => setValor(formatDateInverse(value.target.value))}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoFocus
      />
    </div>
  );
}

function InputTokenTlsFiserv({
  tamMaximo,
  tamMinimo,
  valor,
  setValor,
  cabecalho,
  handleActions,
  label,
  erro,
}) {
  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  function sanitize(next) {
    if (!next) return "";
    const onlyAlnum = next.replace(ALLOWED_RE_2, "");
    return onlyAlnum.slice(0, tamMaximo);
    // return next;
  }

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {label}
      </div>
      <TextInput
        name="token-tls"
        handleEnter={() => handleActions(FECHAR_VENDA_ACTION)}
        label={""}
        handleKey={handleKey}
        value={valor}
        onChange={(value) => setValor(sanitize(value.target.value))}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoFocus
      />
    </div>
  );
}

function getInput(valor, setValor, dados, handleActions, erro) {
  const { tipoCampo, tamMaximo, tamMinimo, valor: label } = dados;
  switch (tipoCampo) {
    case 500:
      return (
        <InputCodigoSupervisor
          tamMaximo={tamMaximo}
          tamMinimo={tamMinimo}
          valor={valor}
          setValor={setValor}
          handleActions={handleActions}
          label={label}
          erro={erro}
        />
      );
    case 505:
      return (
        <InputNumeroParcelasAutocomplete
          tamMaximo={tamMaximo}
          tamMinimo={tamMinimo}
          valor={valor}
          setValor={setValor}
          handleActions={handleActions}
          label={label}
        />
      );
    case 515:
      return (
        <InputDataTransacao
          tamMaximo={tamMaximo}
          tamMinimo={tamMinimo}
          valor={valor}
          setValor={setValor}
          handleActions={handleActions}
          label={label}
          erro={erro}
        />
      );
    case 516:
      return (
        <InputNumeroDocumento
          tamMaximo={tamMaximo}
          tamMinimo={tamMinimo}
          valor={valor}
          setValor={setValor}
          handleActions={handleActions}
          label={label}
          erro={erro}
        />
      );
    case -1:
      return (
        <InputNumeroParcelas
          tamMaximo={tamMaximo}
          tamMinimo={tamMinimo}
          valor={valor}
          setValor={setValor}
        />
      );
    case 2988:
      return (
        <InputTokenTlsFiserv
          tamMaximo={tamMaximo}
          tamMinimo={tamMinimo}
          valor={valor}
          setValor={setValor}
          handleActions={handleActions}
          label={label}
          erro={erro}
        />
      );
    default:
      return null;
  }
}

function FormInput({ handleCancelar, handleConfirmar, dados, cabecalho, aguardandoSitef }) {
  const [valor, setValor] = useState(null);

  function getErro() {
    const { tipoCampo, tamMaximo, tamMinimo } = dados;
    switch (tipoCampo) {
      case 500: {
        if (valor) {
          if (valor.length < tamMinimo) {
            return `Caracteres abaixo do mínimo (${tamMinimo})`;
          } else {
            if (valor.length > tamMaximo) {
              return `Caracteres acima do máximo (${tamMaximo})`;
            }
          }
        } else {
          return ``;
        }

        return "";
      }
      case 505: {
        return "";
      }
      case 515: {
        if (!valor) {
          return `Campo Obrigatório`;
        }
        return "";
      }
      case 516: {
        if (valor) {
          if (valor.length < tamMinimo) {
            return `Caracteres abaixo do mínimo (${tamMinimo})`;
          } else {
            if (valor.length > tamMaximo) {
              return `Caracteres acima do máximo (${tamMaximo})`;
            }
          }
        } else {
          return `Campo Obrigatório`;
        }

        return "";
      }
      case 2988: {
        if (valor) {
          if (valor.length < tamMinimo) {
            return `Caracteres abaixo do mínimo (${tamMinimo})`;
          } else {
            if (valor.length > tamMaximo) {
              return `Caracteres acima do máximo (${tamMaximo})`;
            }
          }
        } else {
          return `Campo Obrigatório`;
        }

        return "";
      }
      default: {
        return "";
      }
    }
  }

  const erro = getErro();

  function handleActions(action) {
    switch (action) {
      case FECHAR_VENDA_ACTION: {
        if (erro === "") {
          //handleConfirmar(parseInt(valor, 10));
          handleConfirmar(valor);
        }
        break;
      }
      case CANCELAR_VENDA_ACTION: {
        handleCancelar();

        break;
      }
      case ESC_ACTION:
        handleCancelar();
        break;
      default:
        break;
    }
  }

  return (
    <div>
      <div>{getInput(valor, setValor, dados, handleActions, erro)}</div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px",
          justifyContent: "space-between",
        }}
      >
        <Button
          //onClick={() => handleCancelar()}
          onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef}
        >
          {`Cancelar (${CANCELAR_VENDA_ACTION})`}
        </Button>
        <Button
          //onClick={() => handleConfirmar(parseInt(valor, 10))}
          onClick={() => handleActions(FECHAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef ? true : erro ? true : false}
          //disabled={aguardandoSitef}
        >
          {`Confirmar (${FECHAR_VENDA_ACTION})`}
        </Button>
      </div>
    </div>
  );
}

function FormCampoMonetario({
  handleCancelar,
  handleConfirmar,
  dados: { tamMaximo, tamMinimo },
  cabecalho,
  aguardandoSitef
}) {
  const [valor, setValor] = useState(0);

  function getErro() {
    let erro = "";
    const minimo = 1;
    const maximo = 10 ** tamMaximo - 1;

    if (valor <= 0 || Number.isNaN(valor)) {
      erro = "Este campo é obrigatório";
    } else {
      if (valor < minimo) {
        erro = `Valor abaixo do mínimo (${formatMoeda(minimo)})`;
      } else {
        if (valor > maximo) {
          erro = `Valor acima do máximo (${formatMoeda(maximo)})`;
        }
      }
    }

    return erro;
  }

  const erro = getErro();

  function handleActions(action) {
    switch (action) {
      case FECHAR_VENDA_ACTION: {
        if (!erro) handleConfirmar(convertToCents2(valor));
        break;
      }
      case CANCELAR_VENDA_ACTION:
        handleCancelar(valor);
        break;
      case ESC_ACTION:
        handleCancelar(valor);
        break;
      default:
        break;
    }
  }

  function handleKey(keyCode, keyName) {
    handleActions(keyName);
  }

  return (
    <div>
      <div
        style={{
          margin: 0,
          //padding: "10px",
          border: "none",
          outline: "none",
          fontSize: "25px",
          fontWeight: "bold",
          marginBottom: "10px",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        {cabecalho}
      </div>
      <PrecoInput
        handleEnter={() => {}}
        label={""}
        handleKey={handleKey}
        value={Number.isNaN(valor) ? "" : String(valor)}
        onChange={(value) => setValor(parseFloat(value.target.value))}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoFocus
      />
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "10px",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef}
        >
          {`Cancelar (${CANCELAR_VENDA_ACTION})`}
        </Button>
        <Button
          onClick={() => handleActions(FECHAR_VENDA_ACTION)}
          color="secondary"
          variant="contained"
          tabindex="-1"
          disabled={aguardandoSitef ? true : erro ? true : false}
        >
          {`Confirmar (${FECHAR_VENDA_ACTION})`}
        </Button>
      </div>
    </div>
  );
}

function getBody(dados, handleContinue, cabecalho, aguardandoSitef) {
  switch (dados.comandId) {
    case 20:
      return (
        <FormSimOuNao
          /* handleCancelar={() => handleContinue(-1, "")}
          handleConfirmar={() => handleContinue(0, "")} */
          handleCancelar={() => handleContinue(0, 1)}
          handleConfirmar={() => handleContinue(0, 0)}
          cabecalho={cabecalho}
          aguardandoSitef={aguardandoSitef}
        />
      );
    case 21:
      return (
        <FormOpcoes
          handleCancelar={(value) => handleContinue(-1, value)}
          handleConfirmar={(value) => handleContinue(0, value)}
          texto={dados.valor}
          cabecalho={cabecalho}
          aguardandoSitef={aguardandoSitef}
        />
      );
    case 23:
      return (
        <FormCancel
          handleCancelar={() => handleContinue(-1, "")}
          cabecalho={cabecalho}
          aguardandoSitef={aguardandoSitef}
        />
      );
    case 30:
      return (
        <FormInput
          handleCancelar={(value) => handleContinue(-1, value)}
          handleConfirmar={(value) =>
            handleContinue(0, value, dados ? dados.tipoCampo : null)
          }
          dados={dados}
          cabecalho={cabecalho}
          aguardandoSitef={aguardandoSitef}
        />
      );
    case 31:

    case 34:
      return (
        <FormCampoMonetario
          handleCancelar={(value) => handleContinue(-1, value)}
          handleConfirmar={(value) => handleContinue(0, value)}
          dados={dados}
          cabecalho={cabecalho}
          aguardandoSitef={aguardandoSitef}
        />
      );
    case 35:

    case 41:

    case 42:
      return (
        <FormOpcoesAprimorado
          handleCancelar={(value) => handleContinue(-1, value)}
          handleConfirmar={(value) => handleContinue(0, value)}
          texto={dados.valor}
          cabecalho={cabecalho}
          aguardandoSitef={aguardandoSitef}
        />
      );
    default:
      return null;
  }
}

function convertToCents(value) {
  return value.toFixed(2).toString().trim().replace(".", ",");
}

function convertToCents2(value) {
  return value.toFixed(2).toString().trim().replace(".", "");
}

const DialogoCpfNota = forwardRef(
  (
    { interfaceSitef, handleResposta: handleResposta2 = () => {}, CupomFiscal, DataFiscal },
    ref
  ) => {
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [dadosColeta, setDadosColeta] = useState({
      tipoCampo: 0,
      tamMaximo: 0,
      tamMinimo: 0,
      valor: 0,
      comandId: 0,
    });
    const [cabecalho, setCabecalho] = useState("");
    const [qrcodePix, setQrcodePix] = useState("");
    const [labelTipoPagamento, setLabelTipoPagamento] = useState("");
    const refDialogoTipoCredito = useRef(null);
    const refDialogoTipoCancelamento = useRef(null);
    const [aguardandoSitef, setAguardandoSitef] = useState(false);
    const [cancelandoPix, setCancelandoPix] = useState(false);

    function resetDados() {
      setDadosColeta({
        tipoCampo: 0,
        tamMaximo: 0,
        tamMinimo: 0,
        valor: 0,
        comandId: 0,
      })
      setQrcodePix('')
      setCabecalho('')
      setLabelTipoPagamento('')
      setCancelandoPix(false);
    }

    function handleResposta(...args) {
      handleResposta2(...args)
      resetDados()
    }

    async function getDadosFiscaisSitef() {
      try {
        const data = await api.get("/gerar-cumpom-fiscal-sitef");
        return {
          CupomFiscal: data.data.cupom,
          DataFiscal: data.data.data,
          HoraFiscal: data.data.hora,
        };
      } catch (e) {
        return null;
      }
    }

    function handleClose() {
      setOpen(false);
    }

    async function getHoraFiscal() {
      try {
        const response = await api.get("/gerar-hora-fiscal-sitef");
        return response.data.hora;
      } catch (e) {
        return null;
      }
    }

    async function vendaCreditoLocal(item, tipoCredito, hasCallFinishTransaction) {
      try {
        resetDados();

        const horaFiscal = await getHoraFiscal();
        if (!horaFiscal) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }

        let prefixo = "";

        switch (tipoCredito) {
          case "credito-a-vista":
            prefixo = "à Vista";
            break;
          case "credito-parcelado-estabelecimento":
            prefixo = "Parcelado pelo Estabelecimento";
            break;
          case "credito-parcelado-administradora":
            prefixo = "Parcelado pela Administradora";
            break;
          default:
            break;
        }

        setLabelTipoPagamento(
          `Parcela CRÉDITO ${prefixo} - ${formatMoeda(item.valor)}`
        );
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);
        const config = {
          valor: convertToCents(item.valor),
          cupomFiscal: CupomFiscal,
          dataFiscal: DataFiscal,
          horaFiscal: horaFiscal,
          hasCallFinishTransaction: hasCallFinishTransaction,
        };
        //const dados = await interfaceSitef.transacaoCredito(config);

        let dados = null;

        switch (tipoCredito) {
          case "credito-a-vista":
            dados = await interfaceSitef.transacaoCredito(config);
            break;
          case "credito-parcelado-estabelecimento":
            dados = await interfaceSitef.transacaoParceladoEstabelecimento(
              config
            );
            break;
          case "credito-parcelado-administradora":
            dados = await interfaceSitef.transacaoParceladoAdministradora(
              config
            );
            break;
          default:
            break;
        }

        setOpen(false);

        if (dados.status) {
          handleResposta(item, dados.message, dados.data);
        } else {
          handleResposta(null, dados.message, null);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function vendaDebitoLocal(item, hasCallFinishTransaction) {
      try {
        resetDados();

        const horaFiscal = await getHoraFiscal();
        if (!horaFiscal) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(`Parcela DÉBITO - ${formatMoeda(item.valor)}`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);
        const config = {
          valor: convertToCents(item.valor),
          cupomFiscal: CupomFiscal,
          dataFiscal: DataFiscal,
          horaFiscal: horaFiscal,
          hasCallFinishTransaction: hasCallFinishTransaction,
        };
        const dados = await interfaceSitef.transacaoDebito(config);
        setOpen(false);

        if (dados.status) {
          handleResposta(item, dados.message, dados.data);
        } else {
          handleResposta(null, dados.message, null);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function vendaPixLocal(item, hasCallFinishTransaction) {
      try {
        resetDados();

        const horaFiscal = await getHoraFiscal();
        if (!horaFiscal) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(
          `Parcela PIX QRCODE - ${formatMoeda(item.valor)}`
        );
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);
        const config = {
          valor: convertToCents(item.valor),
          cupomFiscal: CupomFiscal,
          dataFiscal: DataFiscal,
          horaFiscal: horaFiscal,
          hasCallFinishTransaction: hasCallFinishTransaction,
        };
        const dados = await interfaceSitef.transacaoPix(config);
        setOpen(false);

        if (dados.status) {
          handleResposta(item, dados.message, dados.data);
        } else {
          handleResposta(null, dados.message, null);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function imprimirUltimoCupomLocal() {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(`Reimpressão do Último Cupom TEF`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        const config = {
          cupomFiscal: dadosFiscais.CupomFiscal,
          dataFiscal: dadosFiscais.DataFiscal,
          horaFiscal: dadosFiscais.HoraFiscal,
        };

        const dados = await interfaceSitef.ultimoCupom(config);

        setOpen(false);

        if (dados.status) {
          handleResposta(null, dados.message, dados.data, true);
        } else {
          handleResposta(null, dados.message, null, true);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function imprimirCupomEspecificoLocal() {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(`Reimpressão Cupom Específico TEF`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        const config = {
          cupomFiscal: dadosFiscais.CupomFiscal,
          dataFiscal: dadosFiscais.DataFiscal,
          horaFiscal: dadosFiscais.HoraFiscal,
        };

        const dados = await interfaceSitef.cupomEspecifico(config);

        setOpen(false);

        if (dados.status) {
          handleResposta(null, dados.message, dados.data, true);
        } else {
          handleResposta(null, dados.message, null, true);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function cancelarTransacaoTefLocal() {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(`Cancelar Transação TEF`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        const config = {
          cupomFiscal: dadosFiscais.CupomFiscal,
          dataFiscal: dadosFiscais.DataFiscal,
          horaFiscal: dadosFiscais.HoraFiscal,
        };

        const dados = await interfaceSitef.cancelarTransacaoTef(config);

        setOpen(false);

        if (dados.status) {
          handleResposta(null, dados.message, dados.data, true, true);
        } else {
          handleResposta(null, dados.message, null, true, true);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function cancelarTransacaoTefLocal2(tipoCancelamento) {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }

        let prefixo = "";

        switch (tipoCancelamento) {
          case "cancelamento-debito":
            prefixo = "Cancelamento Débito TEF";
            break;
          case "cancelamento-credito":
            prefixo = "Cancelamento Crédito TEF";
            break;
          case "cancelamento-pix":
            prefixo = "Cancelamento Pix TEF";
            break;
          default:
            break;
        }

        setLabelTipoPagamento(`${prefixo}`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        let dados = null;

        const config = {
          cupomFiscal: dadosFiscais.CupomFiscal,
          dataFiscal: dadosFiscais.DataFiscal,
          horaFiscal: dadosFiscais.HoraFiscal,
        };

        switch (tipoCancelamento) {
          case "cancelamento-debito":
            dados = await interfaceSitef.cancelarDebito(config);
            break;
          case "cancelamento-credito":
            dados = await interfaceSitef.cancelarCredito(config);
            break;
          case "cancelamento-pix":
            dados = await interfaceSitef.cancelarPix(config);
            break;
          default:
            break;
        }

        setOpen(false);

        if (dados.status) {
          handleResposta(null, dados.message, dados.data, true, true);
        } else {
          handleResposta(null, dados.message, null, true, true);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    async function getTransacoesPendentesLocal(item, interfaceSitef) {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(`Tratamento Transações Pendentes`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        const payload = {
          ...item,
          cupomFiscal: dadosFiscais.CupomFiscal,
          dataFiscal: dadosFiscais.DataFiscal,
          horaFiscal: dadosFiscais.HoraFiscal,
        };

        const dados = await interfaceSitef.getTransacoesPendentes(payload);

        setOpen(false);

        return {...dados, dadosFiscais};
      } catch (e) {
        setOpen(false);
        return {
          status: false,
          message: e ? e.toString() : "ERROR",
          data: null,
        };
      }
    }

    async function getTransacaoPendenteIndividualLocal(
      item,
      interfaceSitef,
      indice,
      total
    ) {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(
          `Tratamento Transações Pendentes ${indice}/${total}`
        );
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        const dados = await interfaceSitef.getTransacaoPendenteIndividual(item);

        setOpen(false);

        return dados;
      } catch (e) {
        setOpen(false);
        return {
          status: false,
          message: e ? e.toString() : "ERROR",
          data: null,
        };
      }
    }

    async function menuAdministrativoLocal() {
      try {
        resetDados();

        const dadosFiscais = await getDadosFiscaisSitef();
        if (!dadosFiscais) {
          handleResposta(null, "Erro de comunicacao no servidor", null);
          return;
        }
        setLabelTipoPagamento(`Menu Administrativo TEF`);
        setOpen(true);
        const manipuladores = {
          mensagemVisorOperador,
          mensagemVisorCliente,
          mensagemDoisVisores,
          textoTituloApresentacaoMenu,
          removerMensagemVisorOperador,
          removerMensagemVisorCliente,
          removerMensagemDoisVisores,
          removerTituloApresentacaoMenu,
          apresentarCabecalhoInformacoesAdicionais,
          removerCabecalhoInformacoesAdicionais,
          apresentarTextoEObterRespostaSimOuNao,
          apresentarMenuOpcoes,
          apresentarMensagemOperadorEAguardarTecla,
          interromperProcessoColetaDados,
          lerCampoSemIntervencaoOperador,
          lerCampo,
          lerNumeroCheque,
          lerCampoMonetario,
          coletarCodigoBarras,
          lerCampoMacarado,
          menuIdentificado,
          limparCorpo,
          exibirQrcodePix,
          removerQrcodePix,
        };

        interfaceSitef.setManipuladores(manipuladores);

        const config = {
          cupomFiscal: dadosFiscais.CupomFiscal,
          dataFiscal: dadosFiscais.DataFiscal,
          horaFiscal: dadosFiscais.HoraFiscal,
        };

        const dados = await interfaceSitef.menuAdministrativo(config);

        setOpen(false);

        if (dados.status) {
          handleResposta(null, dados.message, dados.data, false, false, true);
        } else {
          handleResposta(null, dados.message, null, false, false, true);
        }
      } catch (e) {
        setOpen(false);
        handleResposta(
          null,
          `ERRO INESPERADO: ${e ? e.toString() : "ERROR"}`,
          null
        );
      }
    }

    useImperativeHandle(ref, () => ({
      vendaCredito(item, hasCallFinishTransaction) {
        //vendaCreditoLocal(item);
        if (refDialogoTipoCredito.current) {
          refDialogoTipoCredito.current.handleOpen(item, hasCallFinishTransaction);
        }
      },
      vendaDebito(item, hasCallFinishTransaction = false) {
        vendaDebitoLocal(item, hasCallFinishTransaction);
      },
      vendaPix(item, hasCallFinishTransaction = false) {
        vendaPixLocal(item, hasCallFinishTransaction);
      },
      imprimirUltimoCupom() {
        imprimirUltimoCupomLocal();
      },
      imprimirCupomEspecifico() {
        imprimirCupomEspecificoLocal();
      },
      cancelarTransacaoTef() {
        //cancelarTransacaoTefLocal();
        if (refDialogoTipoCancelamento.current) {
          refDialogoTipoCancelamento.current.handleOpen();
        }
      },
      getOpen() {
        return open;
      },
      getTransacoesPendentes(item, interfaceSitef) {
        return getTransacoesPendentesLocal(item, interfaceSitef);
      },
      getTransacaoPendenteIndividual(item, interfaceSitef, indice, total) {
        return getTransacaoPendenteIndividualLocal(
          item,
          interfaceSitef,
          indice,
          total
        );
      },
      menuAdministrativo() {
        menuAdministrativoLocal();
      },
    }));

    // 1
    function mensagemVisorOperador(texto) {
      setCabecalho(texto);
    }

    // 2
    function mensagemVisorCliente(texto) {
      setCabecalho(texto);
    }

    // 3
    function mensagemDoisVisores(texto) {
      setCabecalho(texto);
    }

    // 4
    function textoTituloApresentacaoMenu(texto) {
      setCabecalho(texto);
    }

    // 11
    function removerMensagemVisorOperador() {
      setCabecalho("");
    }

    // 12
    function removerMensagemVisorCliente() {
      setCabecalho("");
    }

    // 13
    function removerMensagemDoisVisores() {
      setCabecalho("");
    }

    // 14
    function removerTituloApresentacaoMenu() {
      setCabecalho("");
    }

    // 15
    function apresentarCabecalhoInformacoesAdicionais(texto) {
      setCabecalho(texto);
    }

    // 16
    function removerCabecalhoInformacoesAdicionais() {
      setCabecalho("");
    }

    // 20
    function apresentarTextoEObterRespostaSimOuNao(texto) {
      setAguardandoSitef(false);
      setCabecalho(texto);
      setDadosColeta({
        tipoCampo: 0,
        tamMaximo: 0,
        tamMinimo: 0,
        valor: 0,
        comandId: 20,
      });
    }

    // 21
    function apresentarMenuOpcoes(texto) {
      //setOpcoes(texto)
      setAguardandoSitef(false);
      setDadosColeta({
        tipoCampo: 0,
        tamMaximo: 0,
        tamMinimo: 0,
        valor: texto,
        comandId: 21,
      });
    }

    // 22
    function apresentarMensagemOperadorEAguardarTecla(texto) {
      alert(texto + "\nPressione enter");
      interfaceSitef.continueTransaction("");
    }

    // 23
    function interromperProcessoColetaDados() {
      setAguardandoSitef(false);
      if (dadosColeta) {
        if (dadosColeta.comandId !== 23) {
          setDadosColeta({
            tipoCampo: 0,
            tamMaximo: 0,
            tamMinimo: 0,
            valor: 0,
            comandId: 23,
          });
        }
      } else {
        setDadosColeta({
          tipoCampo: 0,
          tamMaximo: 0,
          tamMinimo: 0,
          valor: 0,
          comandId: 23,
        });
      }
    }

    // 29
    function lerCampoSemIntervencaoOperador() {
      // não tratar, não vi um caso
    }

    // 30
    function lerCampo(tipoCampo, tamMinimo, tamMaximo, texto) {
      setAguardandoSitef(false);
      setCabecalho(texto);
      setDadosColeta({
        tipoCampo,
        tamMaximo,
        tamMinimo,
        //valor: 0,
        valor: texto,
        comandId: 30,
      });
    }

    // 31
    function lerNumeroCheque() {
      // não tratar, coleta do número do cheque
    }

    // 34
    function lerCampoMonetario(tipoCampo, tamMinimo, tamMaximo, texto) {
      setAguardandoSitef(false);
      setCabecalho(texto);
      setDadosColeta({
        tipoCampo,
        tamMaximo,
        tamMinimo,
        valor: 0,
        comandId: 34,
      });
    }

    // 35
    function coletarCodigoBarras() {
      // não tratar, coleta codigo de barras
    }

    // 41
    function lerCampoMacarado() {}

    // 42
    function menuIdentificado(texto) {
      setAguardandoSitef(false);
      setDadosColeta({
        tipoCampo: 0,
        tamMaximo: 0,
        tamMinimo: 0,
        valor: texto,
        comandId: 42,
      });
    }

    // 50
    function exibirQrcodePix(texto) {
      setQrcodePix(texto);
    }

    // 51
    function removerQrcodePix() {
      setQrcodePix("");
    }

    function limparCorpo() {
      setDadosColeta(null);
    }

    function handleContinue(status, value, tipoCampo) {
      if (aguardandoSitef) return;

      setAguardandoSitef(true);

      interfaceSitef.continueTransaction2(status, value, tipoCampo);
    }

    async function handleCancelarPixAtual() {
      if (cancelandoPix) return;

      setCancelandoPix(true);
      setCabecalho("Cancelando PIX. Aguarde...");
      setQrcodePix("");

      try {
        await interfaceSitef.solicitarCancelamentoTransacaoAtual();
      } catch (e) {
        enqueueSnackbar(
          `Erro ao solicitar cancelamento do PIX: ${e ? e.toString() : "erro"}`,
          { variant: "error" }
        );
      }
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick
          disableEscapeKeyDown
          fullWidth
          maxWidth="sm"
          disableEnforceFocus
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              color: "white",
              backgroundColor: SECONDARY_COLOR,
              textAlign: "center",
            }}
          >
            {`${labelTipoPagamento}`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: "20px 10px",
            }}
          >
            <div>
              {qrcodePix ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <QRCodeCanvas value={qrcodePix} size={400} />
                  <FormCancel
                    /* handleCancelar={() => handleContinue(-1, "")}
                    cabecalho={
                      "Aponte a câmera e pague em seu aplicativo do banco!"
                    } */
                    handleCancelar={handleCancelarPixAtual}
                    cabecalho={
                      cancelandoPix
                        ? "Cancelando PIX. Aguarde..."
                        : "Aponte a câmera e pague em seu aplicativo do banco!"
                    }
                    aguardandoSitef={aguardandoSitef}
                  />
                </div>
              ) : null}
              <div>
                {dadosColeta ? (
                  getBody(dadosColeta, handleContinue, cabecalho, aguardandoSitef)
                ) : (
                  <div
                    style={{
                      margin: 0,
                      //padding: "10px",
                      border: "none",
                      outline: "none",
                      fontSize: "25px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                      marginTop: "10px",
                      textAlign: "center",
                    }}
                  >{`${cabecalho}`}</div>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <DialogoTipoCredito
          ref={refDialogoTipoCredito}
          handleFinalizar={(id, item, hasCallFinishTransaction) => {
            vendaCreditoLocal(item, id, hasCallFinishTransaction);
          }}
          handleCancelar={() => {
            handleResposta(null, "Erro de comunicacao no servidor", null);
            return;
          }}
        />
        <DialogoTipoCancelamento
          ref={refDialogoTipoCancelamento}
          handleFinalizar={(id) => {
            cancelarTransacaoTefLocal2(id);
          }}
          handleCancelar={() => {
            handleResposta(null, "Erro de comunicacao no servidor", null);
            return;
          }}
        />
      </div>
    );
  }
);

export default DialogoCpfNota;
